import { render, staticRenderFns } from "./productAdd.vue?vue&type=template&id=07c048c2&scoped=true"
import script from "./productAdd.vue?vue&type=script&lang=js"
export * from "./productAdd.vue?vue&type=script&lang=js"
import style0 from "./productAdd.vue?vue&type=style&index=0&id=07c048c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c048c2",
  null
  
)

export default component.exports